module.exports = function(){
    require('./translateController');
    require('./headerController');
    require('./homeController');
    require('./canvasController');
    require('./indexController');
    require('./loginController');
    require('./footerController');
    require('./coachingController');
    require('./upgradeController');
    require('./dataHandlingController');
    require('./entryModalController');
    require('./reportController');
}();



// WEBPACK FOOTER //
// ./app/controllers/index.js